import { render } from "./edit_post.vue?vue&type=template&id=15c1fe63&scoped=true"
import script from "./edit_post.vue?vue&type=script&lang=js"
export * from "./edit_post.vue?vue&type=script&lang=js"

import "./edit_post.vue?vue&type=style&index=0&id=15c1fe63&scoped=true&lang=css"
import "./edit_post.vue?vue&type=style&index=1&id=15c1fe63&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c1fe63"]])

export default __exports__